import screenUtil from '../utils/screen';
import breakpoints from '../services/breakpoints';

export function getValueFromThreshold(threshold) {
	if (typeof threshold === 'object' && threshold !== null) {
		const currentBp = breakpoints.getCurrentBreakpoint();

		return isValidThresholdValue(threshold[currentBp]) ? threshold[currentBp] : threshold.default;
	}

	if (typeof threshold === 'string') {
		return screenUtil.getScreenRatioValue(threshold);
	}

	return threshold;
}

function isValidThresholdValue(thresholdValue) {
	if (typeof thresholdValue === 'string') {
		return /^[0-9]+%$/.test(thresholdValue);
	}

	if (typeof thresholdValue === 'number') {
		return !isNaN(thresholdValue) && thresholdValue >= 0;
	}

	return false;
}

export default {
	getValueFromThreshold,
	isValidThresholdValue
};
